import type { Tracker } from '@archipro-website/tracker';

interface TrackProps {
    professional: {
        ID: number;
        Title: string;
    };
    itemID: number;
    itemType: 'professional' | 'product' | 'project' | 'article';
    source: 'page' | 'modal';
}

/**
 * Track the `EnquiryEngagement` event. Triggers when the Enquiry modal opens
 * or an in-page Enquiry form input is focused.
 * @see https://archipro.atlassian.net/browse/CREATIVE-2794
 */
export function trackEnquiryEngagement(tracker: Tracker, props: TrackProps) {
    tracker.log('EnquiryEngagement', {
        url: new URL(window.location.href),
        label: props.professional.Title,
        data: {
            Source: props.source,
            LibraryItemID: props.itemID,
            ItemType: props.itemType,
            ProfessionalID: props.professional.ID,
            ProfessionalTitle: props.professional.Title,
        },
        ga4Data: {
            source: props.source,
            libraryItemID: props.itemID,
            itemType: props.itemType,
            professionalID: props.professional.ID,
            professional: props.professional.Title,
        },
    });
}
